import { render, staticRenderFns } from "./ProjectTeacherCourseView.vue?vue&type=template&id=1dbcac98&scoped=true"
import script from "./ProjectTeacherCourseView.vue?vue&type=script&lang=js"
export * from "./ProjectTeacherCourseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbcac98",
  null
  
)

export default component.exports